import { Modal } from 'bootstrap';

class CustomModal {
    constructor() {
        this.teamPopup();
        this.tabUrl();
    }

    teamPopup() {
        $(document).on('click', '.popup_btn', (e) => {
            e.preventDefault();
            var elem = $(e.currentTarget),
                postid = elem.attr( 'data-id' );

            var data = {
                'postid' : postid,
                'action': 'dwd_team_popup',
            }
            $.ajax({
                url: dwd_object.ajaxurl,
                data: data,
                type: 'POST',
                success: (response) => {
                	$("#myModal").modal('show');
                    $( '.post_content__js' ).html( response.html );
                }
            });
        });
    }
    tabUrl() {
        $(document).ready(() => {
          let url = location.href.replace(/\/$/, "");
         
          if (location.hash) {
            const hash = url.split("#");
            $('#nav-tab a[href="#'+hash[1]+'"]').tab("show");
            url = location.href.replace(/\/#/, "#");
            history.replaceState(null, null, url);
            setTimeout(() => {
              $(window).scrollTop(0);
            }, 400);
          } 
           
          $('a[data-toggle="tab"]').on("click", function() {
            let newUrl;
            const hash = $(this).attr("href");
            if(hash == "#who-are-we") {
              newUrl = url.split("#")[0];
            } else {
              newUrl = url.split("#")[0] + hash;
            }
            newUrl += "";
            history.replaceState(null, null, newUrl);
          });
        });
    }
}

export default CustomModal;
new CustomModal();
